import tw, { styled } from 'twin.macro';

export const StyledSection = styled.section`
  ${tw`px-2 lg:px-0`};
`;

export const StyledContainer = styled.div`
  ${tw`container`}
  ${tw`container-stack-context`};
`;

export const StyledHeader = styled.div`
  ${tw`text-center`}
  ${tw`mb-10 md:mb-8 lg:mx-auto`}
  ${tw`lg:w-2/3`}
  ${tw`lg:w-2/3`}
`;

export const StyledEyebrow = styled.p`
  ${tw`font-inter font-semi-bold uppercase`}
  ${tw`tracking-extra`}
  ${tw`text-primary-p1 text-tag-m`}
  ${tw`mb-2`}
`;

export const StyledHeadline = styled.h2`
  ${tw`mb-2`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-secondary-s1 text-mobile-display-xl lg:text-display-xl`}
`;
